import './sourceViewer.scss';

export const SourseViewerTemplate = (model) => {
	const html = `
	<source-viewer-header></source-viewer-header>
	<source-viewer-body></source-viewer-body>
	<source-viewer-footer></source-viewer-footer>`;
	return html;
};
